import http from "../http-common";

class ExamRemarkService {
  createExamRemark(data) {
    return http.post(`/api/exam_remark`, data);
  }
  getExamRemarks() {
    return http.get(`/api/exam_remark`);
  }
  getExamRemark(data) {
    return http.get('/api/exam_remark' +'?year=' + data.year + '&term=' + data.term + '&exam_type=' + data.exam_type + '&subject_id=' + data.subject_id + '&second_instructor_id=' + data.second_instructor_id);
  }
  updateExamRemark(id, data) {
    return http.put(`/api/exam_remark/${id}`, data);
  }
  deleteExamRemark(data) {    
      return http.delete(`/api/exam_remark` + '?year='+data.year+ '&term='+ data.term+ '&exam_type=' + data.exam_type);
    }
}

export default new ExamRemarkService();